import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router';

import './not_found.scss';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <Card className="not-found__card">
        <i className="pi pi-exclamation-circle not-found__icon" />
        <h2 className='not-found__title'>Страница не найдена</h2>
        <p className="not-found__description">
          К сожалению, запрашиваемая вами страница не существует или была перемещена.
        </p>
        <Button
          label="На главную"
          icon="pi pi-home"
          onClick={() => navigate('/')}
        />
      </Card>
    </div>
  );
}

export default NotFound;
